import { createFileRoute } from "@tanstack/react-router";

import { useMe } from "../features/auth/session";
import { DashboardPage } from "../features/dashboard/DashboardPage";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/")({
  staticData: { wideLayout: true },
  component: DashboardRoute,
});

function DashboardRoute() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return <DashboardPage key={me.data.activeOrganizationId ?? "none"} me={me.data} />;
}
